import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useRouteStore} from '@toolify/client/src/stores/RouteStore/useRouteStore'
import {isStackableRoute} from '@toolify/client/src/setup/router/hooks/isStackableOverlayNavigation'

export function trackRouteLayerRouterHookFactory(pinia: Pinia) {
  return function trackRouteLayerRouterHook(to: RouteLocationNormalized) {
    const routeLayer = to.meta.routeLayer
    if(!routeLayer) {
      return
    }
    if(isStackableRoute(to)) {
      return
    }

    const routeStore = useRouteStore(pinia)
    routeStore.setLastRouteForLayer(routeLayer, {
      path: to.fullPath,
      depth: to.meta.depth ?? 100,
    })
  }
}
